/** The page's entry: runs `pay.ts` on this address, showing what it says in the page (`mount`). */
import { mount } from "./mount.tsx";
import { run, visitorCountry } from "./pay.ts";

/** Build-time constants (build.ts inlines them; local defaults otherwise): the app, and RevenueCat's sandbox key. */
const APP_URL = import.meta.env.REVISA_APP_URL ?? "http://localhost:5173";
const API_KEY = import.meta.env.REVISA_REVENUECAT_PUBLIC_KEY ?? "rcb_sb_KrwEAJzCQOlnHsjNQcRbnHVnz";
const here = globalThis.location;

await run(new URL(here.href), {
  appUrl: APP_URL,
  apiKey: API_KEY,
  show: mount(document.getElementById("app") as HTMLElement, APP_URL, here),
  go: here.assign.bind(here),
  country: visitorCountry,
});
